export const isDebug = (): boolean => {
  return (process.env.NODE_ENV === 'development');
};

export const chunkArray = (stream: any[], size: number): any[][] => stream.reduce((chunks, item, idx, arr) => (idx % size == 0) ? [...chunks, arr.slice(idx, idx + size)] : chunks, []);

export const padZero = (n: number): string => {
  return ("0" + n).slice(-2);
};

export const secondsToHms = (d: number): string => {
  const h = Math.floor(d / 3600);
  const m = Math.floor(d % 3600 / 60);
  const s = Math.floor(d % 3600 % 60);

  const mDisplay = (h > 0 ? h * 60 : 0) + (m > 0 ? m : 0);
  const sDisplay = s > 0 ? s : 0;
  return `${padZero(mDisplay)}:${padZero(sDisplay)}`;
};

export const delay = (time: number): Promise<unknown> => {
  return new Promise(function (resolve) {
    setTimeout(resolve, time)
  });
}

export const genericFilter = (items: Record<string, unknown>, query: string): boolean => {
  return Object.values(items).some((el: any) => {
    if (el) {
      return JSON.stringify(el).toLowerCase().indexOf(query.toLowerCase()) > -1
    } else {
      return false;
    }
  })
}

export const generateId = (): string => {
  return `REF-${Math.random().toString(36).substr(2, 9)}-${Math.random().toString(36).substr(2, 9)}`;
}

export const saveAsJsonLocally = (obj: unknown, filename: string): void => {
  const data = JSON.stringify(obj, null, 2);
  const blob = new Blob([data], { type: 'text/plain' });

  const e = document.createEvent('MouseEvents');
  const a = document.createElement('a');

  a.download = filename;
  a.href = window.URL.createObjectURL(blob);
  a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
  e.initEvent('click', true, false);
  a.dispatchEvent(e);
}

export const exportCSVFile = (headers: Record<string, string>, items: Record<string, unknown>[], fileTitle: string): void => {
  const header = Object.keys(headers);
  const csv = [
    Object.values(headers).join(','), // header row first
    ...items.map(row => header.map(fieldName => JSON.stringify(row[fieldName], (k, v) => v === null ? '' : v)).join(','))
  ].join('\r\n');

  const exportedFilenmae = fileTitle + '.csv' || 'export.csv';

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  if ((navigator as any).msSaveBlob) { // IE 10+
    (navigator as any).msSaveBlob(blob, exportedFilenmae);
  } else {
    const link = document.createElement("a");
    if (link.download !== undefined) { // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", exportedFilenmae);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
